import CustomContainer from "../../components/common/CustomContainer"
import styles from "../../assets/styles/dashboard.module.css"
import { DashboardArrowIcon } from "../../utils/functions/Icons"
import { SsoOHCLoginApi } from "../../utils/api/services"
import { useSelector } from "react-redux"
import { RootState } from "../../utils/store"
import { toast } from "react-toastify"
import { OHC_REDIRECT } from "../../utils/api/routes"

const OHCManagement = () => {
    const { LoginData } = useSelector((state: RootState) => state.auth)

    const handleSSO = async () => {
        if (!LoginData?.email) return
        try {
            const result = await SsoOHCLoginApi(LoginData?.email)
            if (result?.success) {
                const user = result.user ? JSON.stringify(result.user) : ""
                window.open(`${OHC_REDIRECT}/?token=${result?.token}&user=${user}&isHR=true`)
            }
        } catch (error: any) {
            toast.error(error?.message || error?.data?.errors);
        }
    }
    return (
        <CustomContainer>
            <div className='AllPageMain'>
                <div className='HeadAndButton'>
                    <h2>OHC Management</h2>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-3 md:gap-6 gap-y-6 mt-6">
                    <div className={styles.cards}>
                        <div className={styles.ArrIcon} onClick={handleSSO}>
                            <DashboardArrowIcon />
                        </div>
                        <div className={styles.cardContent}>
                            <div className={styles.cardHead}>
                                <h3>View OHC</h3>
                                <small>Click to go to the OHC portal (SSO login)</small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </CustomContainer>
    )
}

export default OHCManagement
